import { CRUDPage } from "./AdminServices";
import { TextInput, TextArea, Toggle } from "./ui";

export default function AdminFAQs() {
  return (
    <CRUDPage
      endpoint="faqs"
      title="SSS / FAQ"
      Form={FAQForm}
      columns={[{ k: "q", l: "Soru" }]}
      emptyModel={{ q: "", a: "", order: 0, active: true }}
      testid="faqs"
    />
  );
}

function FAQForm({ v, set }) {
  return (
    <div className="space-y-4">
      <TextInput label="Soru (varsayılan TR)" value={v.q || ""} onChange={(e) => set("q", e.target.value)} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextInput label="Soru TR (üzerine yazar, opsiyonel)" value={v.title_tr || ""} onChange={(e) => set("title_tr", e.target.value)} />
        <TextInput label="Soru EN" value={v.title_en || ""} onChange={(e) => set("title_en", e.target.value)} />
      </div>
      <TextArea label="Cevap (varsayılan TR)" rows={5} value={v.a || ""} onChange={(e) => set("a", e.target.value)} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextArea label="Cevap TR (opsiyonel)" rows={4} value={v.description_tr || ""} onChange={(e) => set("description_tr", e.target.value)} />
        <TextArea label="Cevap EN" rows={4} value={v.description_en || ""} onChange={(e) => set("description_en", e.target.value)} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <TextInput label="Sıra" type="number" value={v.order ?? 0} onChange={(e) => set("order", parseInt(e.target.value) || 0)} />
        <div className="flex items-end"><Toggle checked={!!v.active} onChange={(x) => set("active", x)} label={v.active ? "Aktif" : "Pasif"} /></div>
      </div>
    </div>
  );
}
